import { create } from "zustand";
import { persist, subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

type SelectConditionParams = { field: string; value: (string | number)[] };
type DateConditionParams = { field: string; gte?: string; lte?: string };
type ConditionItem = SelectConditionParams | DateConditionParams;

export interface GlobalSearchParams {
  query: string;
  semantic_search: boolean;
  conditions: ConditionItem[];
}
export interface FilterParamsItem {
  field: string;
  value: (string | number)[];
}
export interface GlobalSearchParams {
  query: string;
  semantic_search: boolean;
  conditions: ConditionItem[];
}

type ConfigStore = {
  language: string;
  updateLanguage: (data: string) => void;
};

export type NonConfigStore = {
  filter: FilterParamsItem[] | null;
  updateFilter: (data: FilterParamsItem[]) => void;
  search: GlobalSearchParams | null;
  updateSearch: (data: GlobalSearchParams) => void;
};

export const useConfigStore = create<ConfigStore>()(
  persist(
    subscribeWithSelector(
      immer((set, get) => ({
        language: "en",
        updateLanguage(data) {
          set((state) => {
            state.language = data;
          });
        },
      }))
    ),

    {
      name: "global-config-store",
    }
  )
);

export const useNonPersistentFilterItemsStore = create(
  immer<Partial<NonConfigStore>>((set, get) => ({
    filter: [],
    search: null,
    updateFilter(data) {
      set((state) => {
        state.filter = data;
      });
    },
    updateSearch(data) {
      set((state) => {
        state.search = data;
      });
    },
  }))
);

export interface Privilege {
  id: string;
  createdDate: string | null;
  modifiedDate: string | null;
  name: string;
  displayName: string;
  app: string;
  endpoint: string | null;
  method: string | null;
  restrictionTemplate: string | null;
  restriction: string;
  privilege: number;
  domain: string;
  module: string;
  subModule: string;
  path: string | null;
  description: string;
  resourceType: string;
  parentId: string;
  leafNode: number;
  aclId: string | null;
  tenantId: string;
  cookieFlag: boolean;
}
export interface Domain {
  key: string;
  value: string;
  domainPhrase: string;
  abbreviation: string;
}
export interface GlobalConfig {
  state: {
    language: string;
    domain: Domain;
    privilege: Privilege[];
  };
}
export const defaultGlobalConfig: GlobalConfig = {
  state: {
    language: 'en',
    domain: {
      key: '',
      value: '',
      domainPhrase: '',
      abbreviation: '',
    },
    privilege: [],
  },
};
export function isValidGlobalConfig(data: any): data is GlobalConfig {
  let boolvalue = false;
  if (data !== null) {
    if (typeof data.state === 'object' && typeof data.state.language === 'string') {
      if (data.state.domain === null||data.state.domain==undefined) {
        boolvalue = true;
      }
      else {
        if (typeof data.state.domain === 'object' &&
          typeof data.state.domain.key === 'string' &&
          typeof data.state.domain.value === 'string' &&
          typeof data.state.domain.domainPhrase === 'string' &&
          typeof data.state.domain.abbreviation === 'string') {
          boolvalue = true;
        }
      }
      if(data.state.privilege === null||data.state.privilege===undefined) {
        boolvalue = true;
      }
      else{
          if (Array.isArray(data.state.privilege)) 
          {
            boolvalue = true;
          }
          else{
            boolvalue=false;
          }
      }
    }
    else {
      boolvalue = false;
    }


  }
 

  return boolvalue;
}
export const getGlobalConfigStoreValues=()=>{
  let globalConfigStore: GlobalConfig = defaultGlobalConfig;
                            try {
                              const raw = localStorage.getItem('global-config-store');
                              if (raw) {
                                const parsed = JSON.parse(raw);
                                if (isValidGlobalConfig(parsed)) {
                                  globalConfigStore = parsed;
                                } 
                              }
                            } catch (error) {
                            }
          return globalConfigStore;
}